import TreeModel from 'tree-model';
import { FolderDetail, FolderTree } from '@quick/client';
import { EntryType, FolderEntry } from '../views/app-views/documents/FolderEntryList';

export const DOCUMENTS_ROOT_PATH = 'Documents';

export const toPath = (node: TreeModel.Node<FolderTree>) => {
  return node
    .getPath()
    .map((it) => it.model.name)
    .join('/');
};

export const PREVIEW_QUERY_PARAM = 'preview';

export const getFolderEntries = (
  folderDetail: FolderDetail | undefined,
  toUrl: (path: string) => string
): FolderEntry[] => {
  if (!folderDetail) {
    return [];
  }
  const baseUrl = toUrl(folderDetail.path);
  const fileItems = folderDetail.files.map((it) => {
    return {
      type: EntryType.FILE,
      name: it.name,
      member: it.member,
      dateModified: it.dateModified,
      fileRecordId: it.fileRecord.fileRecordId,
      path: `${baseUrl}?${PREVIEW_QUERY_PARAM}=${it.name}`,
    };
  });
  const folderItems = folderDetail.subFolders.map((it) => {
    return {
      type: it.visibleToRoles.length > 0 ? EntryType.LOCKED_FOLDER : EntryType.FOLDER,
      name: it.name,
      member: it.member,
      dateModified: it.dateModified,
      path: baseUrl + '/' + it.name,
    };
  });
  return [...folderItems, ...fileItems].sort(entrySorter);
};

/**
 * Orders entries by type and then by name. `a.type - b.type` puts FOLDER (ordinal=0) before FILE (ordinal=1).
 */
export const entrySorter = (a: FolderEntry, b: FolderEntry) => a.type - b.type || a.name.localeCompare(b.name);
